import { render, staticRenderFns } from "./SoChip.vue?vue&type=template&id=26d266af"
import script from "./SoChip.vue?vue&type=script&lang=js"
export * from "./SoChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports